// src/views/Reports/components/IngredientUsageChart.jsx
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const IngredientUsageChart = ({ data, detailed = false }) => {
  const processData = () => {
    return {
      labels: data.map(item => item[0]),
      datasets: [{
        label: 'Number of Recipes Using',
        data: data.map(item => item[1]),
        backgroundColor: 'rgba(59, 130, 246, 0.7)',
        borderColor: 'rgba(59, 130, 246, 1)',
        borderWidth: 1
      }]
    };
  };

  const options = {
    indexAxis: 'y', // This makes the bar horizontal
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    }
  };

  return <Bar data={processData()} options={options} />;
};

export default IngredientUsageChart;